var render = function render(){var _vm=this,_c=_vm._self._c;return _c('publish-element-title',{attrs:{"sizeNotMatching":_vm.sizeNotMatching,"data":_vm.element.data,"layer":_vm.element.layer}})
}
var staticRenderFns = []

export { render, staticRenderFns }